import {
  type ThemeConfig,
  ThemeDirection,
  extendTheme,
} from "@chakra-ui/react";
import { ChakraTheme } from "@chakra-ui/theme/dist/theme.types";

const direction: ThemeDirection = "rtl";

const config: ThemeConfig = {
  cssVarPrefix: "eren",
  initialColorMode: "light",
  useSystemColorMode: false,
};

/**
 * Override default styles with our custom theme.
 *
 * The complete list of default Chakra styles can be found here:
 * https://github.com/chakra-ui/chakra-ui/tree/main/packages/theme/src
 */
const theme = {
  config,
  direction,
  fonts: {
    heading: `'Figtree Variable', sans-serif`,
    body: `'Figtree Variable', sans-serif`,
  },
  semanticTokens: {
    colors: {
      error: "red.500",
      primary: "themeMain",
      themeMain: "#005884",
      themeSecondary: "#00A39C",
    },
    colorSchemas: {
      primary: "themeMain.500",
      themeMain: {
        50: "rgb(230, 245, 255)",
        100: "rgb(204, 235, 255)",
        200: "rgb(179, 224, 255)",
        300: "rgb(153, 214, 255)",
        400: "rgb(128, 204, 255)",
        500: "rgb(102, 194, 255)",
        600: "rgb(77, 184, 255)",
        700: "rgb(51, 173, 255)",
        800: "rgb(26, 163, 255)",
        900: "rgb(0, 153, 255)",
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        color: 'themeSecondary'
      }
    }
  }
} as Partial<ChakraTheme>;

export default extendTheme(theme);
